module.exports = __webpack_public_path__ + "static/IMG_0006-e8b43c864f48d5ba6fd65eb0bb682ef9.jpg";